// Utils
import cn from '../../../../utils/cn';
// Styles
import styles from './SimpleDateCell.module.css';

/**
 * Simple date cell component for SimpleTable
 * @param {object} props - Component props
 * @param {string} [props.value=''] - Raw date/datetime string from the API (displayed as-is)
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.placeholder='--'] - Placeholder for empty values
 * @param {'left' | 'center' | 'right'} [props.align='left'] - Text alignment
 * @param {boolean} [props.bold=false] - Text in bold
 * @param {boolean} [props.italic=false] - Text in italic
 * @returns {JSX.Element} SimpleDateCell component
 */
export default function SimpleDateCell({
  value = '',
  className = '',
  placeholder = '--',
  align = 'left',
  bold = false,
  italic = false,
}) {
  const isEmpty = !value || value === '';
  const displayValue = isEmpty ? placeholder : value;

  return (
    <div className={cn([
      styles['simple-date-cell'],
      className,
      bold && styles['simple-date-cell-bold'],
      italic && styles['simple-date-cell-italic'],
      align && styles[`simple-date-cell-align-${align}`],
    ])}
    >
      <div
        className={styles['simple-date-cell-value']}
        title={displayValue}
      >
        {displayValue}
      </div>
    </div>
  );
}
